// Domain models and DTOs used across the app
export type BigNumber = number;

export type ProductDTO = {
  id?: number;
  productKey?: string;
  name?: string;
  unitPrice?: BigNumber;
  unit?: 'kg' | 'to.' | 'Stk.';
  quantity?: number;
  description?: string;
};

export type ItemLineDTO = {
  product: ProductDTO;
  quantity: BigNumber;
};

export type CustomerDTO = {
  id?: number;
  customerNumber?: string;
  firstname?: string;
  lastname?: string;
  street?: string;
  buildingNumber?: string;
  postcode?: string;
  city?: string;
  country?: string;
  telephone?: string;
  idCardNr?: string;
  mail?: string;
};

export type InvoiceDTO = {
  customer: CustomerDTO;
  invoiceNumber?: string;
  issueDate?: string; // ISO date (YYYY-MM-DD)
  items: ItemLineDTO[];
};

export function formatMoney(v: number): string {
  if (!isFinite(v)) return '0,00 €';
  return v.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
}
